var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDomain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.865,
    height: 17.865
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h17.865v17.865H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.933 5.637V3H2v11.865h13.865V5.637zm-4.16 7.91H3.387v-1.318h1.386zm0-2.637H3.387V9.592h1.386zm0-2.637H3.387V6.955h1.386zm0-2.637H3.387V4.318h1.386zm2.773 7.91H6.16v-1.317h1.386zm0-2.637H6.16V9.592h1.386zm0-2.637H6.16V6.955h1.386zm0-2.637H6.16V4.318h1.386zm6.933 7.91H8.933v-1.316h1.387V10.91H8.933V9.592h1.387V8.273H8.933V6.955h5.546zm-1.387-5.272h-1.386v1.319h1.387zm0 2.637h-1.386v1.318h1.387z"
  })));
}

export default SvgDomain;